import { NodeModel } from "./node-model";

export class RegistryEntry {
    get id(): string | undefined
    {
        return this.model.node._id;
    }

    constructor(
        public readonly model: NodeModel,
        public readonly element: any
    ) {
    }
}
